import { render, staticRenderFns } from "./DutyDetail.vue?vue&type=template&id=1e999128"
import script from "./DutyDetail.vue?vue&type=script&lang=js"
export * from "./DutyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports